module.exports = __webpack_public_path__ + "img/5-removebg-preview.f9632094.png";